// extracted by css-extract-rspack-plugin
export default {"dialog":"dialog-xZCG6_","group":"group-AOoE1e","groupLabel":"groupLabel-f3hfbT","hint":"hint-oyG4oi","segmented":"segmented-HYXV_q"};